"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useMultiSelectState_controlled = useMultiSelectState_controlled;
exports["default"] = exports.normalizeMultiSelectValue = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = require("react");

var _useSelectState = require("../useSelectState");

function filterProps(props) {
  var options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      allowEmpty = props.allowEmpty,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["options", "value", "defaultValue", "onChange", "allowEmpty"]);
  return restProps;
}

var originalValueArray = function originalValueArray(arr) {
  return arr.map(_useSelectState.originalValue);
};

var getValIndexArray = function getValIndexArray(options, arr) {
  return arr.map(function (val) {
    return (0, _useSelectState.getValIndex)(options, val);
  });
};

var normalizeMultiSelectValue = function normalizeMultiSelectValue(options, val) {
  options = (0, _useSelectState.normalizeSelectOptions)(options);

  if (val === null || val === undefined) {
    return [];
  }

  if (!(0, _isArray["default"])(val)) {
    return [];
  }

  var newVal = [];

  var _loop = function _loop(i) {
    var v = val[i];

    if (v === null || v === undefined) {
      return "continue";
    }

    var valueObject = v;

    if (typeof v !== "object") {
      // if value is not object, then we treat it as id
      valueObject = options.find(function (o) {
        return o.id === v.toString();
      });
    }

    if (!valueObject || valueObject.id === null || valueObject.id === undefined) {
      return "continue";
    }

    valueObject.id = valueObject.id.toString();
    newVal.push(valueObject);
  };

  for (var i = 0; i < val.length; i++) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  }

  return newVal;
};

exports.normalizeMultiSelectValue = normalizeMultiSelectValue;

function are2ArraysOfValuesEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  var ids = {};
  arr1.forEach(function (val) {
    ids[val.id] = true;
  });

  for (var i = 0; i < arr2.length; i++) {
    var id = arr2[i].id;

    if (ids[id] !== true) {
      return false;
    }
  }

  return true;
}

function useMultiSelectState_controlled(props) {
  var options = props.options,
      value = props.value,
      onChange = props.onChange;
  options = (0, _useSelectState.normalizeSelectOptions)(options);
  var normalizedValue = normalizeMultiSelectValue(options, value);

  var setValue = function setValue(newVal) {
    newVal = normalizeMultiSelectValue(options, newVal);

    if (are2ArraysOfValuesEqual(newVal, normalizedValue)) {
      return;
    }

    if (onChange) {
      onChange(originalValueArray(newVal), getValIndexArray(options, newVal));
    }
  };

  var isSelected = function isSelected(val) {
    if (val === undefined || val === null) {
      return false;
    }

    var id = typeof val === "object" ? val.id : val;

    if (normalizedValue.find(function (x) {
      return x.id === id;
    })) {
      return true;
    }

    return false;
  };

  return {
    value: originalValueArray(normalizedValue),
    valueObject: normalizedValue,
    selectedIndex: getValIndexArray(options, normalizedValue),
    options: options,
    reset: function reset() {
      setValue([]);
    },
    setValue: setValue,
    isSelected: isSelected,
    selectValue: function selectValue(val) {
      if (isSelected(val)) {
        return;
      } else {
        setValue([].concat((0, _toConsumableArray2["default"])(normalizedValue), [val]));
      }
    },
    unselectValue: function unselectValue(val) {
      if (!isSelected(val)) {
        return;
      } else {
        setValue(normalizedValue.filter(function (x) {
          return !(x.id === val.id || x.id === val);
        }));
      }
    }
  };
}

function useMultiSelectState(props) {
  var options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      _onChange = props.onChange; // UNCONTROLLED ONLY IF: value === "undefined"

  var isControlled = typeof value !== "undefined";

  var _useState = (0, _react.useState)(normalizeMultiSelectValue(options, defaultValue)),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var currentValue = isControlled ? value : internalValue;
  return useMultiSelectState_controlled((0, _objectSpread2["default"])({}, props, {
    value: currentValue,
    onChange: function onChange(newVal, index) {
      if (!isControlled) {
        setInternalValue(newVal);
      }

      if (_onChange) {
        _onChange(newVal, index);
      }
    }
  }));
}

var _default = useMultiSelectState;
exports["default"] = _default;